import { Bell, CalendarWeek, Coin, Gear, Lock, PatchCheckFill, PersonCircle, Share } from 'react-bootstrap-icons';

import { PAGE_TITLES, ROUTES } from '@repo/common';
import { DataTestIds } from '@repo/frontend-shared';
import type { SettingsPanelItemProps } from '@repo/ui/components/elements/SettingsPanelItem/SettingsPanelItem';

export const settingSidebarItems: SettingsPanelItemProps[] = [
  {
    icon: PersonCircle,
    title: 'Profile',
    path: ROUTES.PROFILE,
    testid: DataTestIds.COMMON.SETTINGS.PROFILE,
  },
  {
    icon: CalendarWeek,
    title: PAGE_TITLES.SETTINGS.AVAILABILITY,
    path: ROUTES.AVAILABILITY,
    testid: DataTestIds.COMMON.SETTINGS.AVAILABILITY,
  },
  {
    icon: Lock,
    title: PAGE_TITLES.SETTINGS.SECURITY,
    path: ROUTES.SECURITY,
    testid: DataTestIds.COMMON.SETTINGS.SECURITY,
  },
  {
    icon: Coin,
    title: PAGE_TITLES.SETTINGS.BILLING,
    path: ROUTES.BILLING,
    testid: DataTestIds.COMMON.SETTINGS.BILLING,
  },
  {
    icon: Bell,
    title: PAGE_TITLES.SETTINGS.NOTIFICATIONS,
    path: ROUTES.NOTIFICATIONS,
    testid: DataTestIds.COMMON.SETTINGS.NOTIFICATIONS,
  },
  {
    icon: Share,
    title: PAGE_TITLES.SETTINGS.INTEGRATIONS,
    path: ROUTES.INTEGRATIONS,
    testid: DataTestIds.COMMON.SETTINGS.INTEGRATIONS,
  },
  {
    icon: PatchCheckFill,
    title: PAGE_TITLES.SETTINGS.MY_MBA,
    path: ROUTES.MY_MBA,
    testid: DataTestIds.COMMON.SETTINGS.MY_MBA,
  },
  {
    icon: Gear,
    title: PAGE_TITLES.SETTINGS.MANAGE_ACCOUNT,
    path: ROUTES.MANAGE_ACCOUNT,
    testid: DataTestIds.COMMON.SETTINGS.MANAGE_ACCOUNT,
  },
];
